import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import InstallerListing from './InstallerListing.js';
import * as actions from "../../../actions/InstallationActions";

export function InstallerList({selectedDate, job, setView, onInstallerSelection}) {

    const dispatch = useDispatch();
    const [installerList, installerJobs] = useSelector(state => state.installerList);
    const vehicleList = useSelector(state => state.vehicleList);
    const [loading, setLoading] = useState(true);

    const installerListVehicleEvents = useSelector(state => state.installerListVehicleEvents);

    useEffect(() => {

        dispatch(actions.VehicleListUpdate());
        dispatch(actions.VehicleListAssociatedWithJob(job.ID));
        dispatch(actions.InstallerListUpdate())
        dispatch(actions.InstallerListSortbyAvailability(selectedDate, installerListVehicleEvents));
        setLoading(false);
    }, [dispatch, selectedDate, job.ID]);


    const formattedDate = new Date(selectedDate).toLocaleDateString('en-GB');

    return (
        <div className="page-section ">
            <div className="container installer-header">
                <button className="btn btn-secondary back-button" onClick={() => setView('calendarMonthView')}>
                    <span className="back-button-arrow"></span> Back
                </button>
                <h2 id="Installers" className="date-header">{formattedDate}: Select Available Installers</h2>
            </div>
            {loading ? (
                <p>loading installer list ....</p>
            ) : (
                installerList && installerJobs && selectedDate && job ? (
                    installerList.map(installer => (
                        <InstallerListing
                            installer={installer}
                            installerJobs={installerJobs}
                            selectedDate={selectedDate}
                            job={job}
                            vehicleList={vehicleList}
                            onInstallerSelection={onInstallerSelection}
                            key={installer.accountID}
                        />
                    ))
                ) : (
                    installerList && installerJobs && selectedDate && job ? (
                        installerList.map(installer => (
                            <InstallerListing
                                installer={installer}
                                installerJobs={installerJobs}
                                selectedDate={selectedDate}
                                job={job}
                                vehicleList={vehicleList}
                                onInstallerSelection={onInstallerSelection}
                                key={installer.accountID}
                            />
                        ))
                    ) : (
                        <p>no content found....</p>
                    )
                )
            )}
        </div>
    );

}
